import create from 'zustand';
import { tourInitialState, sceneInitialState, userInitialState, sceneErrorInitialState, tourErrorInitialState } from './Types'
import { TOUR_PRIVACY } from "./../../constants/TourPrivacy.const";


/********** Middlewares ***********/
const log = config => (set, get, api) => config(args => {
    // console.log("  applying", args)
    set(args)
    // console.log("  new state", get())
}, get, api)



/********** Store ***********/
let useStore = (set => ({

    loggedInUserName: "Vineeth",
    setLoggedInUserName: (loggedInUserName) => set(state => ({ loggedInUserName })),

    user: {
       uid: "", 
       name: "",
       email: "", 
       userRole: ""
    },
    setUser: (payload) => set(state => ({
        user: {...state.user, ...payload}
    })),

    users:[],
    setUsers: (payload) => set(state => ({
        users: [ ...payload ]
    })),
     
    resetUser: () => set(state => ({
        user: { ...userInitialState }
    })),
    
    showHotspotModal: false,
    setShowHotspotModal: (showHotspotModal) => set(state => ({ showHotspotModal })),

    tours: [],
    setTours: (payload) => set(state => ({
        tours:  [ ...payload  ]
    })),
    
    updateTourById: (payload,id) => set(state => ({
        tours: [
            ...state.tours.map((item) => { 
                // eslint-disable-next-line
                if (item.id == id) {
                    return { ...item, ...payload };
                }
                return item;
            })
        ]
    })),
    
    tourFilter: {
       search: "",
       sort: ""
    },
    setTourFilter: (payLoad) => set(state => ({
        tourFilter: {...state.tourFilter, ...payLoad }
    })),

    tourActiveSceneIndex: null,
    setTourActiveSceneIndex: index => set(state => ({ tourActiveSceneIndex: index })),

    tourErrorActiveSceneIndex: null,
    setTourErrorActiveSceneIndex: index => set(state => ({ tourErrorActiveSceneIndex: index })),

    tour: { ...tourInitialState },
    setTourInfo: (payLoad) => set(state => ({
        tour: {
            ...state.tour, 
            info: {
                ...state.tour.info, 
                ...payLoad
            }
        }
    })),

    setTourPrivacy: (payload) => set(state => ({
        tour: {
            ...state.tour, 
            privacy: payload
        }
    })),

    setTour: (payload) => set(state => ({
        tour: { 
            ...payload,
            privacy: payload.privacy || TOUR_PRIVACY.UNLISTED
        }
    })),

    tourError: { ...tourErrorInitialState },
    
    resetTourError: () => set(state => ({
        tourError: { ...tourErrorInitialState }
    })),

    setTourErrorInfo: (payload) => set(state => ({
        tourError: {
            ...state.tourError,
            info: {
                ...state.tourError.info,
                ...payload
            }
        }
    })),
    
    setTourNewSceneError: () => set(state =>({
        tourError: {
            ...state.tourError,
            scenes: [
                ...state.tourError.scenes,
                { ...sceneErrorInitialState }
            ]
        },
       
    })),
    setActiveSceneError: payload => set(state => ({
        tourError:{
            ...state.tourError,
            scenes: [
                ...state.tourError.scenes.map((s,idx) => {
                    if(idx === state.tourErrorActiveSceneIndex){
                        return {
                            ...s,
                            ...payload
                        }
                    }
                    return s
                }),
            ]
        }

    })),
    
    setTourNewSceneAndActiveSceneIndex: () => set(state => ({
        tour: {
            ...state.tour,
            scenes: [
                ...state.tour.scenes,
                { ...sceneInitialState }
            ]
        },
        tourActiveSceneIndex: state.tour.scenes.length,
    })),
    
    setActiveScene: payload => set(state => ({
        tour: {
            ...state.tour,
            scenes: [
                ...state.tour.scenes.map((s, idx) => {
                    if (idx === state.tourActiveSceneIndex) {
                        return {
                            ...s,
                            ...payload
                        }
                    }
                    return s
                }),
            ]
        }
    })),

    setTourSceneNewHotspot: payload => set(state => ({
        tour: {
            ...state.tour, 
            scenes: [
                ...state.tour.scenes.map((s, idx) => {
                    if (idx === state.tourActiveSceneIndex) {
                        return {
                            ...s,
                            hotspots: [ 
                                ...s.hotspots,
                                { ...payload }
                            ]
                        }
                    }
                    return s
                }),
            ]
        },
    })),
    
    setTourSceneNewHotspotError: payload => set(state => ({
        tourError:{
            ...state.tourError,
            scenes: [
                ...state.tourError.scenes.map((s,idx) => {
                    if(idx === state.tourErrorActiveSceneIndex) {
                        return {
                            ...s,
                            hotspots: [
                                ...s.hotspots,
                                {...payload}
                            ]
                        }
                    }
                    return s
                }),
            ]
        }

    })),

    setTourSceneHotspot: payload => set(state => ({
        tour: {
            ...state.tour, 
            scenes: [
                ...state.tour.scenes.map((s, idx) => {
                    if (idx === state.tourActiveSceneIndex) {
                        return {
                            ...s,
                            hotspots: [ 
                                ...s.hotspots.map((h, hIdx) => {
                                  if (hIdx === state.hotspotActiveIndex) {
                                      return {
                                        ...h,
                                        ...payload
                                      }
                                  } 
                                  return h;
                                })
                            ]
                        }
                    }
                    return s
                }),
            ]
        },
    })),
    setTourSceneHotspotError: payload => set(state => ({
        tourError: {
            ...state.tourError, 
            scenes: [
                ...state.tourError.scenes.map((s, idx) => {
                    if (idx === state.tourErrorActiveSceneIndex) {
                        return {
                            ...s,
                            hotspots: [ 
                                ...s.hotspots.map((h, hIdx) => {
                                  if (hIdx === state.hotspotActiveIndex) {
                                      return {
                                        ...h,
                                        ...payload
                                      }
                                  } 
                                  return h;
                                })
                            ]
                        }
                    }
                    return s
                }),
            ]
        },
    })),
    
    removeHotspotFromScene: (hotspotIndex) => set(state => ({
        tour: {
            ...state.tour,
            scenes: [
                ...state.tour.scenes.map((s, idx) => {
                    if (idx === state.tourActiveSceneIndex) {
                        return {
                            ...s,
                            hotspots: [
                                ...s.hotspots.filter((item, index) => index !== hotspotIndex)
                            ]
                        }
                    }
                    return s
                }),
            ]
        },
    })),

    removeTour: (itemId) => set(state =>({
        tours: [
            ...state.tours.filter((item) => item.id !== itemId)
        ]
    })),
   
    removeScene: (tourActiveSceneIndex) => set(state => ({   
        tour: {
            ...state.tour,
            scenes: [ 
                ...state.tour.scenes.filter((s, idx) => idx !== tourActiveSceneIndex)]
        },
    })),
    

    hotspotActiveIndex: null,
    setHotspotActiveIndex: index => set(state => ({ hotspotActiveIndex: index })),
    
    resetTour: () => set(state => ({
        tour: { ...tourInitialState }
    })),

    alertMessage: "",
    setAlertMessage: (alertMessage) => set(state => ({ alertMessage })),  

    notificationMessage: "",
    setNotificationMessage: (notificationMessage) => set(state => ({notificationMessage})),

    loader: "",
    setLoader: (loader) => set(state => ({ loader })), 

    confirmModel: {
        show: "",
        title: "",
        text: "",
        cancelButtonText: "",
        successButtonText: "",
        successCallback: "",
        cancelCallback: ""
    },
    setConfirmModel: (payload) => set(state => ({ 
        confirmModel: {...state.confirmModel, ...payload }
     })),

     pauseHotspotAudio: false,
     setHotspotPauseAudio:(pauseHotspotAudio) => set(state => ({pauseHotspotAudio})),
     
     pauseSceneAudio: false,
     setScenePauseAudio: (pauseSceneAudio) => set(state => ({pauseSceneAudio})),

     changeHotspotPosition: false,
     setChangeHotspotPosition: (changeHotspotPosition) => set(state =>({changeHotspotPosition}))



}))

useStore = log(useStore);
//useStore = persist(useStore, { name: 'AppStore' });

export const useAppStore = create(useStore);
